import { Status } from '../../validation';

export default (status?: Status): boolean => {
    return status === true;
};
